<div class="fs-2 with-close" mat-dialog-title>
    Aperçu de l'annonce
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-7 col-12">
            <img *ngIf="favorite.pictures.length == 0" src="assets/no-photo.png" alt=""/>
            <div *ngIf="favorite.pictures.length > 0" class="picturesCarousel" id="picturesCarouselPreview{{favorite.ad.ai_id}}"
                 class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div *ngFor="let picture of favorite.pictures; index as ig;"
                         [ngClass]="{'carousel-item': true, 'active': ig == 0}">
                        <img *ngIf="picture" src="{{ picture }}"
                             (error)="imageService.changeImg($event, ig, favorite.ad.ai_id)">
                    </div>
                </div>
                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarouselPreview' + favorite.ad.ai_id"
                        data-bs-slide="prev">
                    <i class="fa fa-chevron-left"
                       (click)="trackingService.click('search_result_image_prev', favorite.ad.ai_id);"></i>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarouselPreview' + favorite.ad.ai_id"
                        data-bs-slide="next">
                    <i class="fa fa-chevron-right"
                       (click)="trackingService.click('search_result_image_next', favorite.ad.ai_id);"></i>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="col-md-5 col-12">
            <h3>{{ favorite.title }}</h3>
            <p class="descriptif" [innerHTML]="favorite.description | nl2br"></p>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Fermer
    </button>
    <a *ngIf="favorite.id === '' && favorite.favorite_list.id === ''" class="btn btn-primary"
       [routerLink]="['/app/favorites/open', favorite.ad.ai_id]"
       [queryParams]="{returnUrl: url}"
       (click)="onYesClick();trackingService.click('search_result_open_ad', favorite.ad.ai_id);">
        Ouvrir l'analyse
    </a>
    <a *ngIf="favorite.id !== '' && favorite.favorite_list.id === ''" class="btn btn-primary"
       [routerLink]="['/app/annonces', favorite.id, 'annonce']"
       [queryParams]="{returnUrl: url}"
       (click)="onYesClick();trackingService.click('search_result_open_ad', favorite.ad.ai_id);">
        Ouvrir l'analyse
    </a>
    <a *ngIf="favorite.favorite_list.id !== ''" class="btn btn-primary"
       [routerLink]="['/app/favorites/', favorite.favorite_list.id, favorite.id, 'annonce']"
       (click)="onYesClick();trackingService.click('search_result_open_ad', favorite.ad.ai_id);">
        Ouvrir le favori
    </a>
</div>
